export default "__VITE_ASSET__KG4MgDwk__"